<script setup>
import StatusBadge from '@/components/shared/core/StatusBadge.vue'
</script>

<template>
  <StatusBadge
    :class="$style.badge"
    text="New"
    text-id="unread-badge"
  />
</template>

<style module lang="scss">
.badge {
  background: var(--color-status-danger);
  color: var(--color-white);
}
</style>
